import { UserDto } from 'lib_api/lib/api/gen';

import { createStore } from './utils/createStore';

export const userStore = createStore<UserDto>();

export const UserStoreProvider = userStore.Provider;
export const useUserStore: () => UserDto = () => {
  const user = userStore.useStore()[0];
  return user;
};

export const useUpdateUserStore = () => userStore.useStore()[1];
